/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OnboardRequest } from '../models/OnboardRequest';
import type { OnboardResponse } from '../models/OnboardResponse';
import type { Unit } from '../models/Unit';
import type { User } from '../models/User';
import type { UserInitiateResponse } from '../models/UserInitiateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserControllerService {
    /**
     * @returns User OK
     * @throws ApiError
     */
    public static getUser(): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns User OK
     * @throws ApiError
     */
    public static createUser(
        requestBody: User,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns OnboardResponse OK
     * @throws ApiError
     */
    public static onboard(
        requestBody: OnboardRequest,
    ): CancelablePromise<OnboardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/onboard',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static login(
        requestBody: User,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns UserInitiateResponse OK
     * @throws ApiError
     */
    public static initiateUser(
        requestBody: User,
    ): CancelablePromise<UserInitiateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/initiate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns User OK
     * @throws ApiError
     */
    public static getTrainees(): CancelablePromise<Array<User>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/trainees',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param coupon
     * @returns Unit OK
     * @throws ApiError
     */
    public static checkCoupon(
        coupon: string,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/onboard/coupon/{coupon}',
            path: {
                'coupon': coupon,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @returns User OK
     * @throws ApiError
     */
    public static getUserById(
        id: string,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/id/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
